import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";

import { getInboxList } from "../../../api/getApi";
import LoadingBetRecord from "../../../components/Loading/LoadingBetRecord";
import NotFound from "../../../components/ProgressBlock/NotFound";
import useProcessInboxList from "../../../hook/useProcessInboxList";
import { storeInboxList } from "../../../redux/action/member/memberAction";
import InboxItemSelector from "../InboxItemSelector";

const InboxList = ({ isInbox }) => {
  const [apiCalling, setApiCalling] = useState(true);

  const location = useLocation();

  const inboxList = useProcessInboxList();
  const dispatch = useDispatch();

  useEffect(() => {
    setApiCalling(true);
    getInboxList()
      .then((data) => {
        dispatch(storeInboxList(data?.data));
      })
      .finally(() => {
        setApiCalling(false);
      });
  }, [location.pathname]);

  return (
    <Flex direction={`column`} gap="10px">
      <LoadingBetRecord commonLoading={apiCalling}>
        {inboxList?.length === 0 ? (
          <NotFound />
        ) : (
          inboxList?.map((item, index) => {
            return <InboxItemSelector isInbox key={index} data={item} />;
          })
        )}
      </LoadingBetRecord>
    </Flex>
  );
};

export default InboxList;
